import { ExpandableSection } from "@cloudscape-design/components-themed";
import { isEqual } from "lodash";
import { Dispatch, SetStateAction } from "react";
import { SettlementNoticeEmail } from "../../../features/api-interfaces";
import { formatLabel } from "../../../utils/format";
import { IErrMsg, LABELS } from "../constants";
import { validEmail } from "../validation";
import { EmailInputRow } from "./EmailInputRow";

interface ISettlementNoticeUpdate {
  emailList: SettlementNoticeEmail[];
  setEmailList?: Dispatch<SetStateAction<SettlementNoticeEmail[]>>;
  errMsg?: IErrMsg;
  setErrMsg?: Dispatch<SetStateAction<IErrMsg>>;
  isExpanded: boolean;
  setIsExpanded: Dispatch<SetStateAction<boolean>>;
}

/**
 * 入金口座情報照会・更新 精算額通知先 更新
 */
export const SettlementNoticeUpdate = (props: ISettlementNoticeUpdate) => {
  const {
    emailList,
    setEmailList,
    errMsg,
    setErrMsg,
    isExpanded,
    setIsExpanded,
  } = props;

  /**
   * メールアドレスを入力したときの処理.
   * @param {string} ipid IPID
   * @param {string} inputValue 入力値
   */
  const handleEmailChange = (ipid: string, inputValue: string) => {
    if (errMsg && setErrMsg) {
      const newEmailList = emailList.map((email) =>
        isEqual(email.ipid, ipid) ? { ...email, email: inputValue } : email
      );
      if (setEmailList) {
        setEmailList(newEmailList);
      }
      setErrMsg({
        ...errMsg,
        email: validEmail(errMsg.email, ipid, inputValue),
      });
    }
  };

  return (
    <ExpandableSection
      variant="container"
      headerText={formatLabel(LABELS.SETTLEMENT_NOTICE_TITLE, [
        emailList.length ?? 0,
      ])}
      expanded={isExpanded}
      onChange={() => setIsExpanded(!isExpanded)}
    >
      {emailList.map((email) => (
        <EmailInputRow
          key={email.ipid}
          ipid={email.ipid}
          email={email.email}
          error={errMsg?.email?.[email.ipid]}
          onChange={handleEmailChange}
        />
      ))}
    </ExpandableSection>
  );
};
